import { useCallback, useEffect, useState } from 'react'
import Heatmap from 'visual-heatmap'
import Constants from '../../../../util/Constants'
import { median, q25, q75 } from './Util'

export default function useHeatmap( props ) {
  const { result, url } = props

  const [ imageElement, setImageElement ] = useState()
  const [ heatmap, setHeatmap ] = useState()

  const elementRef = useCallback( ( node ) => {
    if ( node && node !== imageElement ) {
      setImageElement( node );
    }
  }, [] )

  useEffect( () => {
    if ( imageElement && url ) {
      if ( !heatmap ) {
        setHeatmap(
          Heatmap( imageElement, {
            min : 0,
            size : 40,
            intensity : 0.4,
            backgroundImage : {
              url,
              x : 0,
              y : 0,
              height : Constants.HEATMAP_IMAGE_SIZE.thumbnail.height,
              width : Constants.HEATMAP_IMAGE_SIZE.thumbnail.width
            },
            gradient : [
              {
                color : [ 0, 0, 0, 0.0 ],
                offset : 0,
              },
              {
                color : [ 0, 0, 255, 0.2 ],
                offset : 0.2,
              },
              {
                color : [ 0, 255, 0, 0.5 ],
                offset : 0.45,
              },
              {
                color : [ 255, 255, 0, 1.0 ],
                offset : 0.85,
              },
              {
                color : [ 255, 0, 0, 1.0 ],
                offset : 1.0,
              },
            ],
          } )
        )
      }
    }
  }, [ imageElement, url ] )

  useEffect( () => {
    if ( heatmap ) {
      heatmap.setBackgroundImage( {
        url,
        x : 0,
        y : 0,
        height : Constants.HEATMAP_IMAGE_SIZE.thumbnail.height,
        width : Constants.HEATMAP_IMAGE_SIZE.thumbnail.width
      } )

      heatmap.render()
    }
  }, [ url ] )

  useEffect( () => {
    if ( heatmap && result ) {
      const values = result.items.map( item => item.value )
      const bottomQuartile = q25( values )
      const topQuartile = q75( values )
      const med = median( values )
      const iqr = topQuartile - bottomQuartile
      const upperFence = topQuartile + ( 1.5 * iqr )
      const lowerFence = bottomQuartile - ( 1.5 * iqr )

      heatmap.renderData( transformData( result?.items, upperFence, lowerFence ) );
    }
  }, [ result, heatmap ] )

  return {
    result,
    ref : elementRef,
    heatmap
  }
}

function transformData( items, upperFence, lowerFence ) {
  if ( !items || items.length === 0 ) {
    return []
  }

  return items.reduce( ( prev, item ) => {
    if ( item.value <= upperFence && item.value >= lowerFence ) {
      const x = ( item.x * Constants.HEATMAP_IMAGE_SIZE.thumbnail.width ) / Constants.GRID_SIZE.width
      const y = ( item.y * Constants.HEATMAP_IMAGE_SIZE.thumbnail.height ) / Constants.GRID_SIZE.height

      prev.push( {
        ...item,
        value : item.value,
        x,
        y
      } )
    }

    return prev
  }, [] )
}
